import React from 'react'
import { connect, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { SUPER_AUTH_IFRAME_MODAL } from '@chegg-wt/core/state/modals/constants'
import { SADisplay, SADefaultFlow } from '@chegg-wt/core/constants/site'
import {
  SuperAuthIFrameModalData,
  SuperAuthIframeOrigin,
} from '@chegg-wt/core/components/Modals/SuperAuthIFrameModal/types'
import { Config } from '@chegg-wt/core/config'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { loggedInSelector } from '@chegg-wt/core/state/user/selectors'
import * as Styled from './styled'

interface ContainerProps {
  createAccount: (data: SuperAuthIFrameModalData) => void
}

export const CREATE_ACCOUNT_BTN = 'create-account-btn'

export const CreateAccountBanner: React.FunctionComponent<ContainerProps> = ({
  createAccount,
}) => {
  const isLoggedIn = useSelector(loggedInSelector)
  const data: SuperAuthIFrameModalData = {
    display: SADisplay.DIALOG,
    defaultFlow: SADefaultFlow.SIGN_UP,
    origin: SuperAuthIframeOrigin.SOURCE_BANNER_PAGE,
  }
  return !isLoggedIn && Config.showSourcePageAccountCreationBanner ? (
    <Styled.Box>
      <Styled.Container>
        <Styled.KeepCitations>
          Keep all of your citations in one safe place
        </Styled.KeepCitations>
        <Styled.CreateAccount>
          Create an account to save all of your citations
        </Styled.CreateAccount>
      </Styled.Container>
      <Styled.CreateButton
        data-test={CREATE_ACCOUNT_BTN}
        onClick={() => {
          createAccount(data)
        }}
      >
        Create Account
      </Styled.CreateButton>
    </Styled.Box>
  ) : null
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createAccount: (data: SuperAuthIFrameModalData) =>
    dispatch(openModal({ name: SUPER_AUTH_IFRAME_MODAL, data })),
})

export default connect(null, mapDispatchToProps)(CreateAccountBanner)
